import React, { useState, useEffect,useRef,useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import AssetModalWrapper from './AssetModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, Tabs, Card, Timeline, Popconfirm, InputNumber, Checkbox, TimePicker,Radio,Upload,Space,Tag, message } from 'antd';
import { activityPolicy } from '@iso/constants/activityPolicy';
import { deliveryMethods } from '@iso/constants/deliveryMethods';
import { CloseOutlined, UploadOutlined,EditOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import { commonHelper } from '@iso/lib/helpers/commonHelper';
import moment from 'moment';
import { Map, TileLayer, FeatureGroup, Polygon, Tooltip, ZoomControl,Marker,Popup } from 'react-leaflet';
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import { assetService, propertyService,healthsafety,educationSessionService } from '@iso/services';
import ActivityWrap from './ActivityWrap.styles';
import EditActivityModal from './EditActivityModal';
import styled from "styled-components";
import Modal from '@iso/components/Feedback/Modal';
import {
  getSafetyActivityHazardLabel,
  getSafetyActivityHazardCategoryLabel,
  getSafetyActivityHazardCategoryByHazard,
} from '@iso/constants/hazardTypes';

const { Option } = Select;

const ListAcivity = (props) => {
  const [form] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewActivity, setViewActivity] = useState([]);
  const [visibleEditActivity, setVisibleEditActivity] = useState(false);
  const [visibleDeleteActivity, setVisibleDeleteActivity] = useState(false);
  // const [dataActivity, setDataActivity] = useState([]);
  const [activityId, setActivityId] = useState('');
  const mapRef = useRef();
  const [educationSessions, setEducationSessions] = useState({});

  const resolveAttachmentUrl = (attachment) => {
    if (!attachment) return '';
    if (attachment.full_path) {
      return attachment.full_path;
    }
    if (attachment.url) {
      if (/^https?:\/\//i.test(attachment.url)) {
        return attachment.url;
      }
      const base = process.env.REACT_APP_API_BASE_URL || '';
      return `${base}${attachment.url.startsWith('/') ? '' : '/'}${attachment.url}`;
    }
    return '';
  };

  const resolveAttachmentName = (attachment) => {
    const source = attachment?.url || attachment?.full_path || '';
    if (!source) {
      return attachment?.id ? `attachment-${attachment.id}` : 'attachment';
    }
    const parts = source.split('/');
    return parts[parts.length - 1] || source;
  };

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    // Convert UTC to local timezone and format
    return commonHelper.displayDateTimeLocal(dateTimeString, 'DD/MM/YYYY HH:mm');
  };

  // education_sessions.start_time / finish_time are TIME columns (HH:mm:ss),
  // not datetimes — render the time-of-day directly. The session date lives on
  // the parent activity's date_time, rendered above as "Session Date & Time".
  const formatTimeOfDay = (timeString) => {
    if (!timeString) return 'N/A';
    const m = moment(timeString, ['HH:mm:ss', 'HH:mm']);
    return m.isValid() ? m.format('HH:mm') : 'N/A';
  };

  // Load education session data for training_session activities
  useEffect(() => {
    if (props.dataActivity && props.dataActivity.length > 0) {
      const trainingSessions = props.dataActivity.filter(activity => activity.type === 'training_session');

      trainingSessions.forEach(activity => {
        if (activity.id) {
          educationSessionService.getByActivityPolicy(activity.id).then(res => {
            if (res && res.code === '0000' && res.education_session) {
              setEducationSessions(prev => ({
                ...prev,
                [activity.id]: res.education_session
              }));
            }
          });
        }
      });
    }
  }, [props.dataActivity]);

  // useEffect(() => {
  //   if(props.dataId){
  //     setDataActivity(props.dataActivity)
  //   }
  // }, [props.dataId]);

  // const getDataActivity = () => {
  //   healthsafety.getDataActivity(props.dataId).then(res => {
  //     if(res.code === '0000'){
  //       setDataActivity(res.activity_policy);
  //     }
  //   });
  // }
  const onCancelEditActivity  = () => {
    setVisibleEditActivity(false);
  }
  const onHandleEditActivity = (activity) => {
    setViewActivity(activity);
    setVisibleEditActivity(true);
  } 
  const onHandleDeleteActivity = (activity) => {
    setVisibleDeleteActivity(true);
    setActivityId(activity.id);
  }

  const handleCancelActivity = () =>{
    setVisibleDeleteActivity(false);
  } 

  const handleDeleteActivity = () =>{
    healthsafety.destroyActivity(activityId).then(res => {
      if(res.code === '0000'){
        message.success('Activity deleted successfully');
        props.getDataActivity(props.dataId);
        setVisibleDeleteActivity(false);
      } else {
        if (res.message) {
          message.error(res.message);
        } else {
          message.error('Failed to delete activity. Please try again.');
        }
      }
    });
  }

  return(
    <ActivityWrap>
      {
        props.dataActivity.map((activity, index) => { 
                    
          return(
              <div className="wrap-card-activity">
                <div className="wrap-btn-activity"> 
                  <Button type="link" className="btn-n-br btn-edit-activity" onClick={onHandleEditActivity.bind(this, activity)}>
                    <EditOutlined />
                  </Button>
                  <Button type="link" className="btn-n-br btn-delete-activity" onClick={onHandleDeleteActivity.bind(this, activity)}>
                    <CloseOutlined/>
                  </Button> 
                </div>
                <Card title={activity.type.replace(/_/g, ' ')} bordered={true} className="card-activity-title">
                  { activity.type === 'meeting' &&
                    <div>
                      <p><b>Meeting Name: </b> {activity.meeting_name}</p>
                      <p><b> Meeting Attendees: </b> 
                     { activity.metadata.attendees ?
                      activity.metadata.attendees.map((value,key) => {
                        return (
                          <Tag color="#0B2A1B">{value}</Tag>
                        )
                      })
                      : ''
                     }
                      </p>
                      <p><b> Meeting Actions: </b> {activity.metadata.actions}</p>
                      <p><b> Meeting Notes: </b> {activity.metadata.notes}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                    </div>
                  }    
                  { activity.type === 'comment' &&
                    <div>
                      <p><b> Comments: </b> {activity.comments}</p>
                      {activity.metadata.point && 
                      <p><b> Location: </b> <a href={"https://maps.google.com?q="+activity.metadata.point.lat+","+activity.metadata.point.lng } target="_blank" className="btn-edit-activity"> Open Map</a></p>
                      }
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                      <p> <b> Attachment: </b>
                      {
                        activity.attachment.map((value, key) => {
                          const href = resolveAttachmentUrl(value);
                          const nameUrl = resolveAttachmentName(value);
                          return(
                            <div>
                            <a className="attachment-activity" href={href} download={href} target="_blank" rel="noreferrer">{nameUrl}</a>
                            <br/>
                            </div>
                          )
                        })
                      }
                      </p>
                    </div>
                  }    
                  {activity.type === 'update' &&
                    <div>
                      <p> <b>Comments: </b> {activity.metadata.comments}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                      <p> <b> Attachment: </b>  
                      {
                        activity.attachment.map((value, key) => {
                          const href = resolveAttachmentUrl(value);
                          const nameUrl = resolveAttachmentName(value);
                          return(
                            <div>
                              <a className="attachment-activity" href={href} download={href} target="_blank" rel="noreferrer">{nameUrl}</a><br/>
                            </div>
                          )
                        })
                      }
                      </p>
                    </div>
                  }
                  {activity.type === 'safety_walk' &&
                    <div>
                      <p> <b>Notes: </b> {activity.metadata.notes}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                       <p><b> Attendees: </b> 
                       { activity.metadata.attendees ?
                        activity.metadata.attendees.map((value,key) => {
                          return (
                            <Tag color="#0B2A1B">{value}</Tag>
                          )
                        })
                        : ''
                       }
                      </p>
                      <p> <b> Attachment: </b>  
                      {
                        activity.attachment.map((value, key) => {
                          const href = resolveAttachmentUrl(value);
                          const nameUrl = resolveAttachmentName(value);
                          return(
                            <div>
                              <a className="attachment-activity" href={href} download={href} target="_blank" rel="noreferrer">{nameUrl}</a><br/>
                            </div>
                          )
                        })
                      }
                      </p>
                    </div>
                  }
                  {activity.type === 'induction' &&
                    <div>
                      <p> <b>Comments: </b> {activity.metadata.comments}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                      <p><b> Person Running Induction: </b> {activity.metadata.person_running_induction}</p>
                       <p><b> Attendees: </b> 
                       { activity.metadata.attendees ?
                        activity.metadata.attendees.map((value,key) => {
                          return (
                            <Tag color="#0B2A1B">{value}</Tag>
                          )
                        })
                        : ''
                       }
                      </p>
                     
                    </div>
                  }
                  {activity.type === 'toolbox_meeting' &&
                    <div>
                      <p> <b>Comments: </b> {activity.metadata.comments}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                      <p><b> Actions: </b> {activity.metadata.actions}</p>
                      <p><b> Attendees: </b> 
                       { activity.metadata.attendees ?
                        activity.metadata.attendees.map((value,key) => {
                          return (
                            <Tag color="#0B2A1B">{value}</Tag>
                          )
                        })
                        : ''
                       }
                      </p>
                      <p> <b> Attachment: </b>  
                      {
                        activity.attachment.map((value, key) => {
                          const href = resolveAttachmentUrl(value);
                          const nameUrl = resolveAttachmentName(value);
                          return(
                            <div>
                              <a className="attachment-activity" href={href} download={href} target="_blank" rel="noreferrer">{nameUrl}</a><br/>
                            </div>
                          )
                        })
                      }
                      </p>
                     
                    </div>
                  }  
                  {activity.type === 'hazard' &&
                    <div>
                      <p> <b>Comments: </b> {activity.metadata.comments}</p>
                      <p><b> Date Time: </b> {formatDateTime(activity.date_time)}</p>
                      <p><b> Actions: </b> {activity.metadata.actions}</p>
                      {(() => {
                        const hazardCategory = activity.metadata.hazard_category
                          || getSafetyActivityHazardCategoryByHazard(activity.metadata.hazard_type);
                        return hazardCategory ? (
                          <p><b> Hazard category: </b> {getSafetyActivityHazardCategoryLabel(hazardCategory)}</p>
                        ) : null;
                      })()}
                      {activity.metadata.hazard_type && (
                        <p><b> Hazard detail: </b> {getSafetyActivityHazardLabel(activity.metadata.hazard_type)}</p>
                      )}
                      {activity.metadata.hazard_type === 'other' && (
                       <p><b> Hazard detail other: </b> {activity.metadata.hazard_type_other}</p>
                      )}
                      {activity.metadata.point && 
                        <p><b> Location: </b> <a href={"https://maps.google.com?q="+activity.metadata.point.lat+","+activity.metadata.point.lng } target="_blank" className="btn-edit-activity"> Open Map</a></p>
                      }

                    </div>
                  }
                  {activity.type === 'training_session' &&
                    (() => {
                      const session = educationSessions[activity.id];
                      const getDeliveryMethodLabel = (value) => {
                        const method = deliveryMethods.find(m => m.value === value);
                        return method ? method.label : value;
                      };

                      return (
                        <div>
                          <p><b>Training/Course Name: </b> {session?.training_name || activity.metadata.training_name || 'N/A'}</p>

                          <p><b>Session Date & Time: </b> {formatDateTime(activity.date_time)}</p>

                          {session && (
                            <>
                              {session.start_time && (
                                <p><b>Start Time: </b> {formatTimeOfDay(session.start_time)}</p>
                              )}

                              {session.finish_time && (
                                <p><b>Finish Time: </b> {formatTimeOfDay(session.finish_time)}</p>
                              )}

                              {session.trainer_name && (
                                <p><b>Trainer: </b> {session.trainer_name}</p>
                              )}

                              {(session.delivery_methods && session.delivery_methods.length > 0) ? (
                                <p><b>Delivery Methods: </b> {session.delivery_methods.map(m => getDeliveryMethodLabel(m)).join(', ')}</p>
                              ) : session.delivery_method && (
                                <p><b>Delivery Method: </b> {getDeliveryMethodLabel(session.delivery_method)}</p>
                              )}

                              {session.division_name && (
                                <p><b>Division: </b> {session.division_name}</p>
                              )}

                              {session.sites && session.sites.length > 0 && (
                                <p><b>Sites:  <br></br></b>
                                 
                                  {session.sites.map((site, key) => (
                                    <Tag key={key} color="#0B2A1B">
                                      {site.property_name || 'N/A'} - {site.property_address || 'N/A'}
                                    </Tag>
                                  ))}
                                </p>
                              )}

                              {session.trainees && session.trainees.length > 0 && (
                                <div>
                                  <p><b>Trainees: </b></p>
                                  <ul style={{ marginLeft: '20px', marginTop: '5px' }}>
                                    {session.trainees.map((trainee, key) => {
                                      const getCompetencyBadge = (status) => {
                                        if (!status) return null;
                                        const color = status === 'competent' ? 'green' : 'orange';
                                        const label = status === 'competent' ? 'Competent' : 'Not Yet Competent';
                                        return <Tag color={color} style={{ marginLeft: '8px' }}>{label}</Tag>;
                                      };

                                      return (
                                        <li key={key}>
                                          <strong>{trainee.full_name || trainee.name}</strong>
                                          {trainee.trainee_type === 'property_user' ? (
                                            <>
                                              {trainee.email && <span> - {trainee.email}</span>}
                                              {trainee.mobile_phone && <span> - {trainee.mobile_phone}</span>}
                                            </>
                                          ) : (
                                            <span style={{ fontStyle: 'italic', color: '#666' }}> (Outside Trainee)</span>
                                          )}
                                          {trainee.trainee_type === 'outside_trainee' && trainee.email && (
                                            <span> - {trainee.email}</span>
                                          )}
                                          {trainee.trainee_type === 'outside_trainee' && trainee.mobile_phone && (
                                            <span> - {trainee.mobile_phone}</span>
                                          )}
                                          {getCompetencyBadge(trainee.competency_status)}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              )}

                              {session.location_name && (
                                <p><b>Location: </b> {session.location_name}</p>
                              )}

                              {session.equipment && (
                                <p><b>Equipment: </b> {session.equipment}</p>
                              )}
                            </>
                          )}

                          {activity.metadata.notes && (
                            <p><b>Notes: </b> {activity.metadata.notes}</p>
                          )}
                        </div>
                      );
                    })()
                  }
                </Card>
              </div>
            )
         
  
       })
      }
      <EditActivityModal 
        dataId= {props.dataId}
        getDataActivity={props.getDataActivity}
        propertyId={props.propertyId}
        viewActivity={viewActivity}
        visibleEditActivity={visibleEditActivity} 
        onCancelEditActivity={onCancelEditActivity} 
      />
      <DeleteActivityModal 
        className="modal-delete-activity" 
        title="Delete Activity" 
        visible={visibleDeleteActivity} 
        onOk={handleDeleteActivity} 
        onCancel={handleCancelActivity}>
        <p>Do you want to delete?</p>
      </DeleteActivityModal>

    </ActivityWrap>
  )

}

export default ListAcivity;

const DeleteActivityModal = styled(Modal)`
  .ant-btn{
    color: #0B2A1B;
    border-color:#0B2A1B;
  }  
  .ant-btn.ant-btn-primary,.ant-btn.ant-btn-primary:hover{
    background:#0B2A1B;
    color: #fff;
  }   
  
  .ant-btn:hover{
    color: #0B2A1B;
    border-color:#0B2A1B;
  }
`;
